import { Button } from '../../utils/Button';
import { Trash2 } from 'lucide-react';

import { useDispatch, useSelector } from 'react-redux';
import { removeFromCart } from './cartSlice';
import { removeCoupon } from './couponSlice';

export const DeleteItem = ({ productID, selectedVariation }) => {
  const dispatch = useDispatch();
  const cartSessionID =
    useSelector((state) => state.cart.sessionID) ||
    localStorage.getItem('cartSessionID');

  const handleRemoveItem = () => {
    dispatch(removeCoupon());
    if (productID && cartSessionID) {
      dispatch(removeFromCart({ productID, cartSessionID, selectedVariation }));
    }
  };

  return (
    <Button
      className="underline text-sm font-normal"
      onClick={handleRemoveItem}
      aria-label="Remove item"
    >
      Remove
    </Button>
  );
};

export const DeleteItemFromCart = ({ productID, selectedVariation }) => {
  const dispatch = useDispatch();

  const cartSessionID =
    useSelector((state) => state.cart.sessionID) ||
    localStorage.getItem('cartSessionID');

  const handleRemoveItem = () => {
    if (!productID || !cartSessionID) return;

    dispatch(removeFromCart({ productID, cartSessionID, selectedVariation }));
  };

  return (
    <Button onClick={handleRemoveItem} aria-label="Remove item">
      <Trash2 />
    </Button>
  );
};
